import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { DemanderESignature } from 'src/app/core/services/business/model/e-signature/demander-e-signature';
import { ESignatureService } from 'src/app/core/services/business/service/e-signature.service';

@Component({
  selector: 'app-demander-esignature',
  templateUrl: './demander-esignature.component.html',
  styleUrls: ['./demander-esignature.component.scss']
})
export class DemanderESignatureComponent implements OnInit {

  @Input() subitemId;

  form2: FormGroup;
  pressButton: Boolean = false;

  demanderESignature: DemanderESignature = new DemanderESignature();

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _eSignatureService: ESignatureService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      email: [null, Validators.compose([Validators.required])],
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  
  save(): void {
    this.spinner.show();

    this.demanderESignature.subItemId = this.subitemId;
    this.demanderESignature.receiverEmail = this.form2.value.email;
    this.demanderESignature.message = this.form2.value.commentaire;

    this._eSignatureService
      .add(this.demanderESignature)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error
          console.log(error);
          this.spinner.hide();
        }
      );
  }


}
